// extracted by mini-css-extract-plugin
module.exports = {"ingredient":"Ingredient_ingredient__2NNoV"};